export default "__VITE_ASSET__CeA6Gntc__"